import React from "react";
import HomeSuites from "./HomeSuite";
import ScrollAni1 from "./scroll/ScrollAni1";
import ScrollAni2 from "./scroll/ScrollAni2";
import ScrollAni3 from "./scroll/ScrollAni3";
import MobileScroll1 from "./MobileScroll/MobileScroll1";
import MobileScroll2 from "./MobileScroll/MobileScroll2";
import MobileScroll3 from "./MobileScroll/MobileScroll3";

const MainScroll1 = () => {
  const screenWidth = window.innerWidth;

  if (screenWidth <= 960) {
    return (
      <>
        <MobileScroll1 />
        <MobileScroll2 />
        <MobileScroll3 />
      </>
    );
  } else if (screenWidth > 960 && screenWidth <= 1024) {
    return (
      <>
        <ScrollAni1 />
        <ScrollAni2 />
        <ScrollAni3 />
      </>
    );
  } else {
    return <HomeSuites />;
  }
};

export default MainScroll1;
